<template>
  <data-section
    theme="green"
    title="國泰產險-車險"
    :isCarInsurance="true"
    :datas="highlightModify"
    :_fields="
      [
        {
          name: '保單號碼',
          key: 'ceplcno',
          width: 128,
          sortable: true,
          orderByMultiKey: ['ceplcno'],
          orderByMultiType: ['asc']
        },
        {
          name: '險種',
          key: 'cepln_nm',
          width: 98,
          sortable: true,
          orderByMultiKey: ['cepln_nm'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'ceisdnm',
          width: 94,
          sortable: true,
          className: 'link text-underline',
          orderByMultiKey: ['ceisdnm'],
          orderByMultiType: ['asc']
        },
        {
          name: '有效期間',
          key: 'ceplcdt',
          width: 150,
          sortable: true,
          className: 'text-left',
          orderByMultiKey: ['ceplcdt'],
          orderByMultiType: ['asc']
        },
        {
          name: '保費',
          key: 'premium',
          width: 86,
          sortable: true,
          thClassName: 'text-right',
          className: 'text-right',
          orderByMultiKey: ['premium'],
          orderByMultiType: ['asc']
        },
        {
          name: '車牌號碼',
          key: 'lic_no',
          width: 95,
          sortable: true,
          className: 'text-left',
          orderByMultiKey: ['lic_no'],
          orderByMultiType: ['asc']
        },
        {
          name: '引擎號碼',
          key: 'eg_no',
          width: 131,
          sortable: true,
          className: 'text-left',
          orderByMultiKey: ['eg_no'],
          orderByMultiType: ['asc']
        },
        {
          name: '車種',
          key: 'veh_name',
          width: 130,
          sortable: true,
          className: 'text-left',
          orderByMultiKey: ['veh_name'],
          orderByMultiType: ['asc']
        },
        {
          name: '發照日',
          key: 'lic_date',
          width: 86,
          sortable: true,
          className: 'text-left',
          orderByMultiKey: ['lic_date'],
          orderByMultiType: ['asc']
        }
      ].concat(_fields)
    "
    @toggle="
      (isShow) =>
        $router.assignQuery({ CathayPropertyCarInsuranceShow: isShow })
    "
    :initShow="$route.query['CathayPropertyCarInsuranceShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        v-bind="props"
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`CathayPropertyCarInsuranceShort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`CathayPropertyCarInsuranceShort`]
            ? JSON.parse($route.query[`CathayPropertyCarInsuranceShort`])
            : null
        "
      >
        <template slot="ceplcno" scope="item">
          <span :class="{ 'text-blue': item.data.isKeyinBySelf }">{{
            item.data.ceplcno
          }}</span>
        </template>
        <template slot="ceplcdt" scope="item">
          <div
            class="pre-formatted"
            v-html="
              buildStartEndWithTimeString(
                getROCDate(item.data.ceplcdt),
                getROCDate(item.data.celpsdt),
                item.data.ceplcdt_time,
                item.data.celpsdt_time,
              )
            "
          ></div>
        </template>
        <template slot="ceisdnm" scope="item">
          <span @click="routeToCustDetail(item.data.ceisdno ,item.data.ceisdnm)">
            {{ item.data.ceisdnm | truncate }}
          </span>
        </template>
        <template slot="premium" scope="item"
          >{{ item.data.premium | numberFormat }}元</template
        >
        <template slot="lic_date" scope="item">{{
          getROCDateCar(item.data.lic_date)
        }}</template>
        <template slot="action" scope="item">
          <a
            role="button"
            class="text-red text-underline"
            @click="doDelete(item.data)"
            >刪除</a
          >
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import HighlightModify from "./HighlightModify";
import { deleteSelfInputPropertyNumber } from "@/service";

export default {
  mixins: [InsuranceMixins, HighlightModify],
  methods: {
    async doDelete(data) {
      await this.$deleteConfirm(
        this.buildDeleteMessage(`${data.ceplcno} ${data.cepln_nm}`)
      );
      await this.deleteSuccessHandler(
        deleteSelfInputPropertyNumber(
          this.$store.state.userInfo.id,
          data.ceplcno,
          ""
        )
      );
      this.isLoading = true;
      this.$bus.emit(
        "cathay-car-insurance.get",
        () => (this.isLoading = false)
      );
    }
  }
};
</script>
